import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isOptedOut, pauseContributor, resumeContributor, startContributor, subscribe, } from '../compute/contributor';
/**
 * Indicador VISIBLE de la contribución de cómputo del navegador + control de
 * opt-out. Transparencia por diseño: el visitante siempre ve que su navegador
 * está aportando potencia y puede pausarlo con un clic.
 */
export default function ComputeContributor() {
    const { t } = useTranslation();
    const [s, setS] = useState({ running: false, units: 0, bytes: 0, lastError: null });
    const [optedOut, setOptedOut] = useState(isOptedOut());
    useEffect(() => {
        startContributor(); // on por defecto (salvo opt-out persistido)
        return subscribe(setS);
    }, []);
    const pause = () => { pauseContributor(); setOptedOut(true); };
    const resume = () => { resumeContributor(); setOptedOut(false); };
    return (_jsxs("div", { className: "contrib-badge", role: "status", "aria-live": "polite", title: t('contrib.tooltip'), children: [_jsx("span", { className: `contrib-dot ${s.running ? 'on' : 'off'}`, "aria-hidden": true, children: "\u26A1" }), optedOut ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "contrib-text", children: t('contrib.paused') }), _jsx("button", { type: "button", className: "contrib-btn", onClick: resume, children: t('contrib.resume') })] })) : (_jsxs(_Fragment, { children: [_jsxs("span", { className: "contrib-text", children: [t('contrib.active'), " \u00B7 ", t('contrib.units', { count: s.units })] }), _jsx("button", { type: "button", className: "contrib-btn", onClick: pause, children: t('contrib.pause') })] }))] }));
}
